"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.syntheticProcess = exports.removeMasterLoanTapeArtifacts = exports.addMasterLoanTapeArtifacts = exports.createMasterLoanTape = exports.createFromPressassignedLoanTapeType = exports.createFromMasterLoanTapeType = exports.parseRawMasterLoanTapeArtifactSlug = void 0;
const lodash = __importStar(require("lodash"));
const remeda_1 = require("remeda");
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils = __importStar(require("../dbNodes/utils"));
const tape_builder_base_1 = require("../types/tape-builder-base");
const { includes, cloneDeep, remove, isNil } = lodash;
/**
 * TODO: this ultimately can get cleaned up eventually, as we now have made
 * "rawMasterLoanTapeArtifactSlug" mandatory as part of "Generated Loan Tape"
 * configuration. This was needed to help with validation, as Xlsx2Csv flows
 * does not have your typical "rawLoanTape" that we can depend on
 *
 * Keeping this in the interim to not break existing normal flows that relies
 * on the fallback behavior that this function provides
 */
const parseRawMasterLoanTapeArtifactSlug = ({ generatedLoanTape, dataTapes, }) => {
    const configuredRawMasterLoanTapeArtifactSlug = generatedLoanTape.configuration.rawMasterLoanTapeArtifactSlug;
    if (configuredRawMasterLoanTapeArtifactSlug) {
        const artifact = utils.findArtifactBySlug({
            artifactSlug: configuredRawMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        return artifact.artifactSlug;
    }
    const { creditFacilitySlug, loanProductSlug } = generatedLoanTape;
    // we need to check for both cfSlug + lpSlug,
    // as preassigned loan tape may have multiple raw tape
    // for same lpSlug
    const rawMasterLoanTapeArtifacts = (0, remeda_1.filter)(dataTapes, (tape) => tape.loanProductSlug === loanProductSlug &&
        tape.creditFacilitySlug === creditFacilitySlug &&
        tape.type === 'rawLoanTape');
    (0, common_1.finleyAssert)(rawMasterLoanTapeArtifacts.length === 1, `Unable to find raw loan tape artifact slug ${configuredRawMasterLoanTapeArtifactSlug}`);
    return rawMasterLoanTapeArtifacts[0].artifactSlug;
};
exports.parseRawMasterLoanTapeArtifactSlug = parseRawMasterLoanTapeArtifactSlug;
const createFromMasterLoanTapeType = ({ generatedLoanTape, rawMasterLoanTapeArtifactSlug, }) => {
    (0, common_1.finleyAssert)(isNil(generatedLoanTape.creditFacilitySlug), 'creditFacilitySlug of generatedLoanTape masterLoanTape type must be nil');
    (0, common_1.finleyAssert)(generatedLoanTape.loanProductSlug, 'loanProductSlug of generatedLoanTape must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'masterLoanTape',
        configuration: {
            generatedMasterLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(generatedLoanTape.artifactSlug),
            rawMasterLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(rawMasterLoanTapeArtifactSlug),
        },
        loanProductSlug: generatedLoanTape.loanProductSlug,
        creditFacilitySlug: null,
        artifactDocumentId: generatedLoanTape.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `masterLoanTape_${generatedLoanTape.loanProductSlug}`, // uniq "master" archetypes
    };
};
exports.createFromMasterLoanTapeType = createFromMasterLoanTapeType;
const createFromPressassignedLoanTapeType = ({ generatedLoanTape, rawMasterLoanTapeArtifactSlug, }) => {
    (0, common_1.finleyAssert)(generatedLoanTape.creditFacilitySlug, 'creditFacilitySlug of generatedLoanTape preassignedMasterLoanTape type must be defined');
    (0, common_1.finleyAssert)(generatedLoanTape.loanProductSlug, 'loanProductSlug of generatedLoanTape must be defined');
    return {
        id: (0, uuid_1.v4)(),
        type: 'masterLoanTape',
        configuration: {
            generatedMasterLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(generatedLoanTape.artifactSlug),
            rawMasterLoanTapeArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(rawMasterLoanTapeArtifactSlug),
        },
        loanProductSlug: generatedLoanTape.loanProductSlug,
        creditFacilitySlug: generatedLoanTape.creditFacilitySlug,
        artifactDocumentId: generatedLoanTape.artifactDocumentId,
        externalFilename: null,
        artifactSlug: `masterLoanTape_${generatedLoanTape.loanProductSlug}_${generatedLoanTape.creditFacilitySlug}`, // uniq for preassigned
    };
};
exports.createFromPressassignedLoanTapeType = createFromPressassignedLoanTapeType;
const createMasterLoanTape = ({ generatedLoanTape, rawMasterLoanTapeArtifactSlug, loanTapeTypeMap, }) => {
    const { loanProductSlug } = generatedLoanTape;
    (0, common_1.finleyAssert)(loanProductSlug, 'loanProductSlug must exist for generatedLoanTape');
    const loanTapeType = loanTapeTypeMap[loanProductSlug];
    (0, common_1.finleyAssert)(loanTapeType, `loanTypeType must exist for ${loanProductSlug}`);
    switch (loanTapeType) {
        case 'preassignedLoanTape':
            return (0, exports.createFromPressassignedLoanTapeType)({
                generatedLoanTape,
                rawMasterLoanTapeArtifactSlug,
            });
        case 'masterLoanTape':
        case 'preassignedMasterLoanTape':
            return (0, exports.createFromMasterLoanTapeType)({
                generatedLoanTape,
                rawMasterLoanTapeArtifactSlug,
            });
        default:
            return (0, common_1.finleyAssertUnreachable)(loanTapeType);
    }
};
exports.createMasterLoanTape = createMasterLoanTape;
/**
 * Create and inserts master loan tape artifacts in between generatedLoanTape and
 * receivableResponseTape. rawLoanTape is wired in as a second input to the master
 * so all receivables are available.
 *
 *                        *** Current ***
 * +-------------------+      +------------------------+
 * | generatedLoanTape | ---> | receivableResponseTape |
 * +-------------------+      +------------------------+
 *
 *                        *** Revised ***
 * +-------------------+      +----------------+      +------------------------+
 * | generatedLoanTape | ---> | masterLoanTape | ---> | receivableResponseTape |
 * +-------------------+      +----------------+      +------------------------+
 *                              ^
 * +-------------------+        |
 * |    rawLoanTape    | -------+
 * +-------------------+
 */
const addMasterLoanTapeArtifacts = ({ loanTapeTypeMap, dbGraph, }) => {
    const dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    utils.ensureNoDuplicateDependencies({
        functionName: 'addMasterLoanTapeArtifacts Begin',
        dbGraph,
    });
    const generatedLoanTapes = utils.filterGeneratedLoanTapes({ dataTapes });
    const receivableResponseTapes = utils.filterReceivableResponseTapes({
        dataTapes,
    });
    const receivableResponseTapeIds = (0, remeda_1.map)(receivableResponseTapes, ({ id }) => id);
    (0, remeda_1.forEach)(generatedLoanTapes, (generatedLoanTape) => {
        const rawMasterLoanTapeArtifactSlug = (0, exports.parseRawMasterLoanTapeArtifactSlug)({
            generatedLoanTape,
            dataTapes,
        });
        // if we have configured a rawMasterLoanTape that is not the original
        // we need to make sure it has the same cfSlug configuration as
        // generated loan tape
        const configuredRawMasterLoanTapeArtifact = utils.findArtifactBySlug({
            artifactSlug: rawMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        if (configuredRawMasterLoanTapeArtifact.type !== 'rawLoanTape') {
            const removedTapes = remove(dataTapes, (tape) => tape.artifactSlug === rawMasterLoanTapeArtifactSlug);
            (0, common_1.finleyAssert)(removedTapes.length === 1, 'unable to remove configuredRawMasterLoanTapeArtifact');
            const updatedTape = {
                ...removedTapes[0],
                creditFacilitySlug: generatedLoanTape.creditFacilitySlug,
                loanProductSlug: generatedLoanTape.loanProductSlug,
            };
            dataTapes.push(updatedTape);
        }
        const masterLoanTape = (0, exports.createMasterLoanTape)({
            generatedLoanTape,
            rawMasterLoanTapeArtifactSlug,
            loanTapeTypeMap,
        });
        // add masterLoanTape.
        dataTapes.push(masterLoanTape);
        // add an edge from generatedLoanTape => masterLoanTape
        dataTapeDependencies.push({
            outputArtifactId: masterLoanTape.id,
            inputArtifactId: generatedLoanTape.id,
        });
        const rawMasterLoanTapeArtifact = utils.findArtifactBySlug({
            artifactSlug: rawMasterLoanTapeArtifactSlug,
            dataTapes,
        });
        // add rawLoanTape as dependency to master loan tape
        dataTapeDependencies.push({
            outputArtifactId: masterLoanTape.id,
            inputArtifactId: rawMasterLoanTapeArtifact.id,
        });
        // find edges from GeneratedLoanTape => ReceivableResponseTapes
        const dependencies = (0, remeda_1.filter)(dataTapeDependencies, (dep) => includes(receivableResponseTapeIds, dep.outputArtifactId) &&
            dep.inputArtifactId === generatedLoanTape.id);
        // for each GeneratedLoanTape => ReceivableResponseTapes edge
        dependencies.forEach((dep) => {
            // remove edge from GeneratedLoanTape => ReceivableResponseTapes
            // remove mutates original array
            const removedDependencies = remove(dataTapeDependencies, (dependency) => dependency.inputArtifactId === dep.inputArtifactId &&
                dependency.outputArtifactId === dep.outputArtifactId);
            (0, common_1.finleyAssert)(removedDependencies.length === 1, 'unable to remove dependency');
            // add edge from MasterLoanTape => ReceivableResponseTapes
            dataTapeDependencies.push({
                outputArtifactId: removedDependencies[0].outputArtifactId,
                inputArtifactId: masterLoanTape.id,
            });
        });
    });
    utils.ensureNoDuplicateDependencies({
        functionName: 'addMasterLoanTapeArtifacts end',
        dbGraph,
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addMasterLoanTapeArtifacts = addMasterLoanTapeArtifacts;
/**
 * Removes the synthetic masterLoanTape and reconnects generatedLoanTape directly
 * to receivableResponseTape (the inverse of {@link addMasterLoanTapeArtifacts}).
 *
 *                        *** Current ***
 * +-------------------+      +----------------+      +------------------------+
 * | generatedLoanTape | ---> | masterLoanTape | ---> | receivableResponseTape |
 * +-------------------+      +----------------+      +------------------------+
 *                              ^
 * +-------------------+        |
 * |    rawLoanTape    | -------+
 * +-------------------+
 *
 *                        *** Revised ***
 * +-------------------+      +------------------------+
 * | generatedLoanTape | ---> | receivableResponseTape |
 * +-------------------+      +------------------------+
 *
 * Only masterLoanTape -> receivableResponseTape links are rebuilt as
 * generatedLoanTape -> receivableResponseTape. Any other outgoing generatedLoanTape
 * edges are preserved rather than discarded (ENG-7001).
 */
const removeMasterLoanTapeArtifacts = (graph) => {
    const dataTapes = cloneDeep(graph.dataTapes);
    const generatedLoanTapes = utils.filterGeneratedLoanTapes({ dataTapes });
    for (const generatedLoanTape of generatedLoanTapes) {
        const rawSlug = (0, exports.parseRawMasterLoanTapeArtifactSlug)({
            generatedLoanTape,
            dataTapes,
        });
        const raw = utils.findArtifactBySlug({ dataTapes, artifactSlug: rawSlug });
        if (raw.type !== 'rawLoanTape') {
            const removed = remove(dataTapes, (tape) => tape.artifactSlug === rawSlug);
            (0, common_1.finleyAssert)(removed.length === 1, 'unable to remove configuredRawMasterLoanTapeArtifact');
            dataTapes.push({
                ...removed[0],
                creditFacilitySlug: null,
                loanProductSlug: null,
            });
        }
    }
    const masters = utils.filterMasterLoanTapes({ dataTapes });
    const masterIds = new Set(masters.map((tape) => tape.id));
    const generatedIds = new Set(generatedLoanTapes.map((tape) => tape.id));
    const responseIds = new Set(utils.filterReceivableResponseTapes({ dataTapes }).map((tape) => tape.id));
    const restored = graph.dataTapeDependencies
        .filter((edge) => masterIds.has(edge.inputArtifactId) &&
        responseIds.has(edge.outputArtifactId))
        .map((edge) => {
        const master = masters.find((tape) => tape.id === edge.inputArtifactId);
        (0, common_1.finleyAssert)(master, 'Master loan tape must exist');
        const generated = utils.findArtifactBySlug({
            dataTapes,
            artifactSlug: master.configuration.generatedMasterLoanTapeArtifactSlug,
        });
        return {
            inputArtifactId: generated.id,
            outputArtifactId: edge.outputArtifactId,
        };
    });
    return {
        dataTapes: dataTapes.filter((tape) => !masterIds.has(tape.id)),
        dataTapeDependencies: [
            ...graph.dataTapeDependencies.filter((edge) => !masterIds.has(edge.inputArtifactId) &&
                !masterIds.has(edge.outputArtifactId) &&
                // Only response-tape links are reconstructed; other outputs must survive (ENG-7001).
                (!generatedIds.has(edge.inputArtifactId) ||
                    !responseIds.has(edge.outputArtifactId))),
            ...restored,
        ],
    };
};
exports.removeMasterLoanTapeArtifacts = removeMasterLoanTapeArtifacts;
exports.syntheticProcess = {
    toDb: (dbGraph, { loanTapeTypeMap }) => (0, exports.addMasterLoanTapeArtifacts)({ dbGraph, loanTapeTypeMap }),
    fromDb: exports.removeMasterLoanTapeArtifacts,
};
//# sourceMappingURL=masterLoanTape.js.map